<template>
  <van-overlay show z-index="1000" :lock-scroll="false">
    <van-popup v-model="show" position="bottom" :style="{height: '90%',overflow:'hidden'}" :close-on-click-overlay="false"
               :lock-scroll="false">
      <div class="px-4 pt-6">
        <div class="text-center truncate">
          <span class="font-bold text-large">{{agreeTitle}}</span>
        </div>
      </div>
      <div class="border-b border-solid border-border-gray py-3" :style="{height:contentHeight}">
        <div class="h-full overflow-auto">
          <div class="agree-content px-4 " v-html="option.contentText"></div>
        </div>
      </div>
      <div v-if="needSignature" class="px-4 mt-2 pb-3 border-b border-solid border-border-gray">
        <div class="flex justify-between items-center">
          <span>请在下方矩形框内绘制签名</span>
          <van-button plain size="small" @click="clear">清空</van-button>
        </div>
        <div class="canvas-wrapper mt-2">
          <canvas ref="canvasRef" :width="canvasWidth" height="150"></canvas>
        </div>
      </div>
      <div class="mt-4 px-4">
        <div>
          <van-button type="info" block :disabled="(minReadTime > 0) || loading" @click="agree" :loading="loading">
            {{ agreeBtnText }}
            <template v-if="minReadTime > 0">
              （ {{ minReadTime }}秒后继续 ）
            </template>
          </van-button>
        </div>
        <div v-if="showDisagreeBtn" class="mt-2">
          <van-button :loading="loading" :disabled="loading" block @click="onDisagree">{{ disagreeBtnText }}</van-button>
        </div>
        <InfoSnapshot
            ref="infoSnapshot"
            :title="agreeTitle"
            :content="option.contentText"
            :signature-url="signatureUrl"
        />
      </div>
    </van-popup>
    <van-popup v-model="showWeixinAuth" position="bottom" :style="{height: '100%'}">
      <div class="text-center" style="padding-top: 30vh;">
        <div><span>微信授权后才能参与</span></div>
        <div class="mt-2">
          <van-button class="auth-btn mt-5" block type="primary" @click="onAuth">一键授权</van-button>
        </div>
      </div>
    </van-popup>
  </van-overlay>
</template>

<script>
import Signature from 'signature_pad'
import { Notify } from 'vant'
import { dataURLToBlob, upload } from 'dygc'
import InfoSnapshot from './InfoSnapshot.vue'

export default {
  name: 'AgreeInfo',
  components: { InfoSnapshot },
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: false,
      canvasWidth: 0,
      minReadTime: 0,
      showWeixinAuth: false,
      signatureUrl: null,
      loading: false
    }
  },
  computed: {
    contentHeight() {
      let h = 420
      if (!this.needSignature) h = 200
      return `calc(100% - ${h}px)`
    },
    agreeTitle() {
      return this.option.title || '知情同意书'
    },
    agreeBtnText() {
      return this.option.agreeBtnText || '同意并继续'
    },
    disagreeBtnText() {
      return this.option.disagreeBtnText || '不同意并退出'
    },
    showDisagreeBtn() {
      return this.option.showDisagreeBtn || false
    },
    needSignature() {
      return this.option.needSignature || false
    }
  },
  mounted() {
    this.show = true
    this.canvasWidth = window.innerWidth - 16 * 2
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    getSignatureUrl() {
      let signature = this.signature

      let dataURL = signature.toDataURL('image/png')
      let blob = dataURLToBlob(dataURL)
      const f = new File([blob], Date.now() + '.png')
      let fd = new FormData()
      fd.append('file', f)
      return fd
    },
    agree() {
      if (this.option.needWechatAuth && !this.$bus.params.accountUserId) {
        this.showWeixinAuth = true
        return
      }
      this.loading = true
      if (this.signature) {
        if (this.signature.isEmpty()) {
          Notify({
            type: 'danger',
            message: '请签名'
          })
          this.loading = false
        } else {
          const fd = this.getSignatureUrl()
          this.signatureUrl = this.signature.toDataURL('image/png')
          this.$nextTick(()=>{
            this.$refs.infoSnapshot.getSnapshot().then((snap)=>{
              this.$emit('confirm', fd,snap)
              this.loading = false
            }).catch(()=>{
              this.$emit('confirm', fd)
              this.loading = false
            })
          })
        }
      } else {
        this.$refs.infoSnapshot.getSnapshot().then((snap)=>{
          this.$emit('confirm',null,snap)
          this.loading = false
        }).catch(()=>{
          this.$emit('confirm')
          this.loading = false
        })
      }
    },
    onDisagree() {
      if (this.option.disagreeJump && /^http[s]?:\/\/.*/.test(this.option.disagreeJumpLink || '')) {
        window.location.href = this.option.disagreeJumpLink
      } else {
        if (window.wx) {
          wx.closeWindow()
        } else {
          this.$emit('cancel')
        }
      }
    },
    init() {
      this.minReadTime = this.option.minReadTime || 0
      if (this.minReadTime > 0) {
        this.agreeTimer = setInterval(() => {
          this.minReadTime -= 1
          if (this.minReadTime <= 0) {
            clearInterval(this.agreeTimer)
          }
        }, 1000)
      }
      if (!this.needSignature) return
      let el = this.$refs.canvasRef
      let signature = this.signature = new Signature(el, {})

      this.$nextTick(() => {
        this.drawGrid('#ccc', 10, 10)
      })
    },
    drawGrid(color, stepx, stepy) {
      let canvas = this.$refs.canvasRef
      let context = canvas.getContext('2d')
      context.save()
      context.fillStyle = 'white'
      let cw = context.canvas.width
      let ch = context.canvas.height
      context.fillRect(0, 0, cw, ch)
      context.lineWidth = 0.5
      context.strokeStyle = color
      const fn = (x, y, lx, ly) => {
        context.beginPath()
        context.moveTo(x, y)
        context.lineTo(lx, ly)
        context.closePath()
        context.stroke()
      }
      for (let i = stepx; i < cw; i += stepx) {
        fn(i, 0, i, ch)
      }
      for (let j = stepy; j < ch; j += stepy) {
        fn(0, j, cw, j)
      }
      context.restore()
    },
    clear() {
      this.$nextTick(() => {
        this.signature.clear()
        this.drawGrid('#ccc', 10, 10)
      })
    },
    onAuth() {
      this.$answerUtil.wxAuthorization(null)
    }
  }
}
</script>

<style scoped lang="scss">
.auth-btn {
  width: 184px;
  margin: 0 auto;
  background-color: #07c160 !important;
  border: 1px solid #07c160 !important;
  position: relative;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 17px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  border-radius: 4px;
  overflow: hidden;
  height: 36px !important;
}

.canvas-wrapper {
  canvas {
    @apply border border-solid border-border-gray;
  }
}
</style>
